import { basicEnum } from "./base";

export const ProfitUnitEnum = basicEnum([
    {
        label: "Rupiah (Rp.)",
        value: "fixed",
    },
    {
        label: "Persentase (%)",
        value: "scale",
    },
]);

export namespace ProfitUnitEnum {
    export type Labels = (typeof ProfitUnitEnum)["labels"][number];
    export type Values = (typeof ProfitUnitEnum)["values"][number];
}
